import { Alert, LinearProgress, Stack } from "@mui/material"
import { useMemo, useState } from "react"
import { CloudSync, CloudUpload } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab"
import API from "../../../services/API";
import {Upload} from 'tus-js-client';
import Progress from "../../Tools/Progress";
import { useEffect } from "react";
import Loader from "../../Tools/Loader";
import { txt } from "../../../services/translation";

//const maxSize = 10000000000;

const accept = {
    'video/x-flv': 'flv',
    'video/mp4': 'mp4',
    'application/x-mpegURL': 'm3u8',
    'video/MP2T': 'ts',
    'video/3gpp': '3gp',
    'video/quicktime': 'mov',
    'video/x-msvideo': 'avi',
    'video/avi': 'avi',
    'video/x-ms-wmv': 'wmv'
};

const errors = {
    errorFileMissing: txt("errorFileMissing"),
    errorFileExtension: txt("errorFileExtension"),
    errorFileType: txt("errorFileType"),
    errorFileSize: txt("errorFileSize"),
    errorVideo: txt("errorVideo"),
    errorUrl: txt("errorUrl"),
    errorUpload: txt("errorUpload"),
};


export default function VimeoUpload({id, onChange}){

    const [status, setStatus] = useState('loading')

    const [progress, setProgress] = useState(0)

    const [video, setVideo] = useState(null)

    const showButton = useMemo(() => !video || video.status === 'available', [video])

    useEffect(() => {

        setStatus('loading')
        setProgress(0)
        setVideo(null)
        
        API.get(`/design/sections/${id}/video`)
            .then(r => setVideo(r.data))
            .catch(e => setVideo(null))
            .finally(() => setStatus('ready'))

    }, [id])

    const statusIs = str => str === status

    const statusIn = arr => arr.includes(status)

    const handleFile = file => {

        console.log(file)

        if(!file) return setStatus('errorFileMissing');

        let extension = file.name.split('.').pop();

        if(!accept[file.type]){

            return setStatus('errorFileType');

        }else if(accept[file.type] !== extension){

            return setStatus('errorFileExtension');

        }/*else if(file.size > maxSize){

            return setStatus('errorFileSize');
        }*/

        createVideo(file)
    }

    const createVideo = file => {

        const data = {name: file.name, size: file.size};

        API.post(`/design/sections/${id}/video`, data)
            .then(r => uploadVideo(file, r.data))
            .catch(e => setStatus('errorVideo'))

        setStatus('create')
        setVideo(null)
    }

    const uploadVideo = (file, video) => {

        console.log(video)

        const uploadUrl = video?.upload?.upload_link;

        if(!uploadUrl) return setStatus('errorUrl');

        const upload = new Upload(file, {
            endPoint: 'https://api.vimeo.com/me/videos',
            uploadUrl: uploadUrl,
            retryDelays: [0, 3000, 5000, 10000, 20000],
            metadata: {filename: file.name, filetype: file.type},
            headers: {},
            onError: error => {
                console.error(error)
                setStatus('errorUpload')
            },
            onProgress: (bytesUploaded, bytesTotal) => {
                let percentage = Math.round(bytesUploaded / bytesTotal * 100);
                setProgress(percentage)
            },
            onSuccess: () => setStatus('success')
        });
      
        upload.start();

        setVideo(video)
        setStatus('upload')

        return onChange(video)
    }

    const handleChange = e => {
        let files = e.target.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrop = e => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrag = e => e.preventDefault();

    return statusIs('loading') ? <Loader /> : 
    
        <Stack spacing={1}>

            {showButton && 
                <LoadingButton 
                    startIcon={<CloudUpload />}
                    variant='outlined'
                    onClick={() => document.getElementById('vimeoupload' + id).click()}
                    loading={statusIn(['create','upload'])}
                    sx={{flex: 1, borderStyle: 'dashed', minHeight: 80}}
                    onDrop={handleDrop}
                    onDragOver={handleDrag}
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    size='large'
                >
                    {txt("dropVideo")}
                </LoadingButton>
            }


            {status.startsWith('error') && 
                <Alert severity='error'>{errors[status]}</Alert>
            }


            {statusIs('success') && 
                <Alert severity='success'>{txt('successVideoUpload')}</Alert>
            }


            {statusIs('upload') && 
                <Progress value={progress} />
            }


            <input
                id={'vimeoupload' + id} 
                type="file" 
                style={{display: 'none'}}
                onChange={handleChange}
                accept={Object.keys(accept).join(',')}
            />


            {video?.status === 'available' && 
                <iframe
                    title="Vimeo Player"
                    src={video.player_embed_url}
                    height={300}
                    frameBorder='none'
                />
            }

            {(video?.status || '').startsWith('transcod') && 
                <Stack>
                    <LinearProgress color='info' />
                    <Alert severity='info' icon={<CloudSync />}>{txt('infoVideoTranscoding')}</Alert>
                </Stack>
            }

        </Stack>
}